import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { DataTable, HelperViewContextual } from '@warrenbrasil/nebraska-web';
import {
  DerivativesFiltersDateValues,
  IDerivativesFilters,
  DerivativesFiltersTypes,
  DerivativesFiltersTypeValues
} from '../../types';
import { columns } from './columns';
import {
  ForwardContractPosition,
  OptionPosition
} from '@/modules/trade/services/instruments/types';

interface Props {
  filters: IDerivativesFilters;
  isLoading: boolean;
  itemsPerPage: number;
  items: ForwardContractPosition[] | OptionPosition[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DerivativesTable',
  props: {
    filters: null,
    isLoading: { type: Boolean },
    itemsPerPage: null,
    items: null
  },
  setup(__props: any) {

const props = __props as {
  filters: IDerivativesFilters;
  isLoading: boolean;
  itemsPerPage: number;
  items: ForwardContractPosition[] | OptionPosition[];
}



const tablesConfig = computed(() => [
  {
    type: DerivativesFiltersDateValues.Today,
    subType: DerivativesFiltersTypeValues.Options,
    columns:
      columns[DerivativesFiltersDateValues.Today][
        DerivativesFiltersTypeValues.Options
      ]
  },
  {
    type: DerivativesFiltersDateValues.Historical,
    subType: DerivativesFiltersTypeValues.Options,
    columns:
      columns[DerivativesFiltersDateValues.Historical][
        DerivativesFiltersTypeValues.Options
      ]
  },
  {
    type: DerivativesFiltersDateValues.Today,
    subType: DerivativesFiltersTypeValues.Forwards,
    columns:
      columns[DerivativesFiltersDateValues.Today][
        DerivativesFiltersTypeValues.Forwards
      ]
  },
  {
    type: DerivativesFiltersDateValues.Historical,
    subType: DerivativesFiltersTypeValues.Forwards,
    columns:
      columns[DerivativesFiltersDateValues.Historical][
        DerivativesFiltersTypeValues.Forwards
      ]
  }
]);
const status = computed(() => (props.isLoading ? 'loading' : 'default'));

return { __sfc: true,props, tablesConfig, status, DataTable, HelperViewContextual, DerivativesFiltersTypes, columns }
}

})